import React from "react";
import PropTypes from "prop-types";
import { List, useNotify, useTranslate, useResourceContext } from "react-admin";
import { useNavigate } from "react-router";

const CustomList = ({ children, ...props }) => {
  const t = useTranslate();
  const notify = useNotify();
  const navigate = useNavigate();
  const resource = useResourceContext();

  const onError = ({ message }) => {
    if (message.includes("datex_error")) {
      notify("resources.notifications.errors.datex_error", {
        type: "error",
        autoHideDuration: 3000,
      });

      return navigate({
        pathname: "/error_page",
      });
    }
    if (message.includes("plugin_inactive")) {
      return notify(`resources.notifications.errors.${message}`, {
        type: "error",
        autoHideDuration: 3000,
        messageArgs: { resource: t(`resources.${resource}.name`) },
      });
    }
    return notify(`resources.notifications.errors.${message}`, {
      type: "error",
      autoHideDuration: 3000,
    });
  };

  return (
    <List queryOptions={{ onError }} {...props}>
      {children}
    </List>
  );
};

CustomList.propTypes = {
  children: PropTypes.node,
};

export default CustomList;
